import { render, staticRenderFns } from "./DeferForm.vue?vue&type=template&id=07c545c4&"
import script from "./DeferForm.vue?vue&type=script&lang=js&"
export * from "./DeferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports